import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UptimeTypography, UptimeButton, UptimeModal } from '@uptime/uptime-component';
import { ModalProps } from 'components/ModalProps';

export interface PunchOutModalProps extends ModalProps {
  /** The title of the modal */
  title: string;

  /** Allows users to pass content to modal */
  message: string;

  /** href path for punch out */
  url: string;

  /** The text to display on the call to action, if
   * no text is provided the string "Continue" will
   * be used as default
   */
  callToAction?: string;
}

/**
 * Dialog modal to take user to an external service when tenant is unsubscribed
 * @param props
 */
const PunchOutModal: React.FC<PunchOutModalProps> = ({
  title,
  message,
  url,
  callToAction,
  isModalOpen,
  setIsModalOpen,
}) => {
  const { t } = useTranslation('common');
  useEffect(() => {
    UptimeModal.setAppElement('body');
  });

  return (
    <>
      <UptimeModal
        kind="primary"
        heading={title}
        closeButtonAriaLabel={t('common:close')}
        isOpen={isModalOpen}
        onRequestClose={() => {
          setIsModalOpen(false);
        }}
      >
        <UptimeModal.Body>
          <UptimeTypography kind="body1">{message}</UptimeTypography>
        </UptimeModal.Body>
        <UptimeModal.Footer>
          <UptimeButton kind="text" onClick={() => setIsModalOpen(false)} marginX={2}>
            {t('common:close')}
          </UptimeButton>
          <a target="_blank" rel="noopener noreferrer" href={url}>
            <UptimeButton
              kind="primary"
              onClick={() => setIsModalOpen(false)}
              marginX={2}
            >
              {callToAction || t('common:continue')}
            </UptimeButton>
          </a>
        </UptimeModal.Footer>
      </UptimeModal>
    </>
  );
};
export default PunchOutModal;
